import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Typography, makeStyles, useMediaQuery, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import ButtonNavigation from '../../ButtonNavigation/ButtonNavigation';
import sanitizer from '../../../services/sanitize-service';
import allActions from '../../../store/actions';
import buildPaths from '../../../utils/paths';
import { getTranslation } from '../../../utils/functions';
import {
  introSelector,
  textsOverwritingsSelector,
} from '../../../store/selectors/globalConfigSelectors';

const useTermsFormStyles = (isMobileView) =>
  makeStyles((theme) => ({
    card: {
      padding: isMobileView ? '28px 20px' : '40px 66px',
    },
    contentWrapper: {
      height: isMobileView ? '100%' : '500px',
      display: 'flex',
      flexDirection: 'column',
      overflow: isMobileView ? 'initial' : 'auto',
      justifyContent: 'center',
    },
    contentWrapperOpen: {
      overflow: 'visible',
      height: 'auto',
    },
    title: {
      position: 'absolute',
      left: 12,
      top: 0,
      margin: 0,
      transform: 'translateY(-50%)',
      padding: 4,
      backgroundColor: theme.palette.common.white,
      zIndex: 2,
      fontWeight: 500,
      fontSize: theme.custom.fontSize.subsection,
    },
    titleMobile: {
      marginTop: 0,
      marginBottom: 16,
      fontWeight: 500,
      fontSize: theme.custom.fontSize.subsection,
    },
    board: {
      position: 'relative',
      marginTop: isMobileView ? 32 : 40,
      width: '100%',
      border: isMobileView ? 'none' : `1px solid ${theme.palette.grey[300]}`,
      height: '100%',
      minHeight: 200,
      borderRadius: 5,
    },
    separator: {
      display: isMobileView ? 'none' : 'block',
    },
    expandButton: {
      padding: '30px 0 32px 0',
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    checkboxField: {
      marginTop: 12,
      marginBottom: 12,
      alignItems: 'flex-start',
    },
    checkbox: {
      paddingTop: 0,
    },
    expandButtonContainer: {
      padding: '32px 0',
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
  }));

const IntroForm = () => {
  const PATHS = buildPaths();

  const { intro, textsOverwritings } = useSelector((state) => ({
    intro: introSelector(state),
    textsOverwritings: textsOverwritingsSelector(state),
  }));
  const { t } = useTranslation();

  const history = useHistory();
  const dispatch = useDispatch();
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const classes = useTermsFormStyles(isMobileView)();

  const redirectToRegisterForm = () => {
    dispatch(allActions.appConfigActions.setAccessToRegister(true));
    history.push(PATHS.register);
  };

  return (
    <Card className={classes.card}>
      <Box className={cx(classes.contentWrapper)}>
        <Typography style={{ marginBottom: '40px', marginTop: '20px' }} variant="h4">
          {intro.title && getTranslation(intro.title)}
        </Typography>
        {
          intro.introductionText && (
            <Typography
            dangerouslySetInnerHTML={{
              __html: sanitizer(getTranslation(intro.introductionText)),
            }}
          />
          )
        }
       
      </Box>
      
      <Box component="section" display="flex" justifyContent="flex-end">
        <ButtonNavigation onClick={redirectToRegisterForm} next>
          {textsOverwritings ? getTranslation(textsOverwritings, 'BUTTON_CONTINUE') : t('BUTTON_CONTINUE')}
        </ButtonNavigation>
      </Box>
    </Card>
  );
};

export default IntroForm;
